import { X } from 'lucide-react';
import { useEffect } from 'react';

export const Modal = ({ isOpen, onClose, title, children, isLight }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex justify-center items-center animate-in fade-in-50"
      onClick={onClose}
    >
      <div 
        className={`relative rounded-2xl p-8 border transition-all duration-300 w-[90%] max-w-md m-4 ${isLight ? 'bg-white text-slate-900 border-slate-200' : 'bg-[#0d0d0f] text-white border-white/10'}`}
        onClick={e => e.stopPropagation()}
      >
        <button 
          onClick={onClose}
          className={`absolute top-4 right-4 p-2 rounded-full transition-colors ${isLight ? 'hover:bg-slate-100' : 'hover:bg-white/10'}`}
        >
          <X size={18} />
        </button>
        
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        
        <div className={isLight ? 'text-slate-600' : 'text-slate-400'}>
          {children}
        </div>
      </div>
    </div>
  );
};
